module.exports = __webpack_public_path__ + "src/asset/svg/wallpattern.svg?018564067cf884a4e8b6f336890f37ea";


//////////////////
// WEBPACK FOOTER
// ./src/asset/svg/wallpattern.svg
// module id = 106
// module chunks = 0